/*
  product-greeting-card.js
  Handles the optional greeting card widget on the camp package product page.
  - Expand / collapse the card panel
  - Live card preview with writable textarea overlay
  - Character counter
  - Stores card data in window.pgcData so the Add to Cart handler can inject
    it as line_item properties in the /cart/add.js call
*/

(function () {
  function initProductGreetingCard() {
    var wrapper = document.getElementById('product-greeting-card');
    if (!wrapper || wrapper.dataset.pgcInitialized === 'true') return;
    wrapper.dataset.pgcInitialized = 'true';

    var addBtn      = document.getElementById('pgc-add-btn');
    var removeBtn   = document.getElementById('pgc-remove-btn');
    var section     = document.getElementById('pgc-section');
    var cardPreview = document.getElementById('pgc-card-preview');
    var previewImg  = document.getElementById('pgc-preview-img');
    var textarea    = document.getElementById('pgc-message');
    var footer      = document.getElementById('pgc-footer');
    var charCounter = document.getElementById('pgc-char-counter');
    var saveStatus  = document.getElementById('pgc-save-status');

    var MAX_CHARS   = 300;
    var autoDesign  = wrapper.getAttribute('data-auto-design') || '1';
    var cardImgUrls = {
      '1': wrapper.getAttribute('data-card-img-1'),
      '2': wrapper.getAttribute('data-card-img-2')
    };

    // Shared data store — read by the ATC handler in main-camp-package-product.liquid
    window.pgcData = { active: false, design: null, message: '' };

    // ── Expand ──
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        section.classList.add('open');
        addBtn.classList.add('hidden');

        // Set correct card image based on product tag
        if (previewImg) {
          previewImg.src = cardImgUrls[autoDesign];
          previewImg.alt = 'Card Design ' + autoDesign;
        }
        if (cardPreview) {
          cardPreview.setAttribute('data-card', autoDesign);
          cardPreview.classList.add('visible');
        }
        if (footer) {
          footer.style.display = 'flex';
        }
        if (textarea) {
          textarea.focus();
        }

        // Update shared state
        window.pgcData.active = true;
        window.pgcData.design = autoDesign;
        window.pgcData.message = textarea ? textarea.value : '';

        updateStatusLabel('Ready');
      });
    }

    // ── Collapse & Clear ──
    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        section.classList.remove('open');
        if (addBtn) addBtn.classList.remove('hidden');

        if (cardPreview) {
          cardPreview.classList.remove('visible');
          cardPreview.removeAttribute('data-card');
        }
        if (footer) footer.style.display = 'none';
        if (textarea) textarea.value = '';
        if (saveStatus) saveStatus.textContent = '';
        updateCharCounter(0);

        // Clear shared state
        window.pgcData = { active: false, design: null, message: '' };
      });
    }

    // ── Textarea → Counter + data update ──
    if (textarea) {
      var previousValue = '';

      textarea.addEventListener('input', function () {
        var text = this.value;

        if (text.length > MAX_CHARS) {
          text = text.substring(0, MAX_CHARS);
          this.value = text;
        }

        // Prevent vertical overflow from extra lines
        if (this.scrollHeight > this.clientHeight) {
          this.value = previousValue;
          updateCharCounter(this.value.length);
          return;
        }

        previousValue = this.value;
        updateCharCounter(this.value.length);

        // Keep shared state in sync
        window.pgcData.message = this.value;
        updateStatusLabel('');
      });

      // Prevent the change event from bubbling up to Dawn's product form validators
      textarea.addEventListener('change', function (event) {
        event.stopPropagation();
      });
    }

    // ── Helper: character counter ──
    function updateCharCounter(count) {
      if (!charCounter) return;
      charCounter.textContent = count + '/' + MAX_CHARS;
      charCounter.classList.remove('near-limit', 'at-limit');
      if (count >= MAX_CHARS) {
        charCounter.classList.add('at-limit');
      } else if (count >= Math.floor(MAX_CHARS * 0.85)) {
        charCounter.classList.add('near-limit');
      }
    }

    function updateStatusLabel(text) {
      if (saveStatus) saveStatus.textContent = text;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGreetingCard);
  } else {
    initProductGreetingCard();
  }
})();
